export default __webpack_public_path__ + "static/wave-de38dc74a46e7f5b9e10d819af028a31.mp4";